<template>
    <div class="home">
        <van-icon class="user" name="wap-nav" size="27" @click="$refs.userTabbar.show()" />
        <user-tabbar ref="userTabbar" />

        <div class="banner">
            <div class="banner-img" :style="{ background: 'url(' + dailySentence.thumb + ')' }"></div>
            <p>读经 | {{ dailySentence.publish_at }}</p>
            <p>{{ dailySentence.content }}</p>
        </div>

        <van-grid clickable :column-num="4" :border="false" icon-size="40">
            <van-grid-item text="代祷" to="/intercession" :icon="require('@/assets/images/icons/daidao.png')" />
            <van-grid-item text="视频" to="/video" :icon="require('@/assets/images/icons/shipin.png')" />
            <van-grid-item text="阅读" to="/article" :icon="require('@/assets/images/icons/wenzhang.png')" />
            <van-grid-item text="答题" to="/paper_period" :icon="require('@/assets/images/icons/wenda.png')" />
        </van-grid>

        <div class="column">
            <div class="column-title">
                <span>文集</span><span v-if="anthologies.length > 3" @click="toAnthology">查看更多</span>
            </div>
            <div class="column-content">
                <div class="content-item" v-for="item in anthologies" :key="item.id" @click="anthology(item.id)">
                    <img class="content-item-img" :src="item.thumb" alt="" />
                    <span>{{ item.title }}</span>
                </div>
            </div>
        </div>

        <div class="column">
            <div class="column-title"><span>专辑</span><span v-if="audios.length > 3">查看更多</span></div>
            <div class="column-content">
                <div class="content-item" v-for="item in audios" :key="item.id" @click="audio(item.id)">
                    <img class="content-item-img" :src="item.thumb" alt="" />
                    <span>{{ item.title }}</span>
                    <span>讲道</span>
                </div>
            </div>
        </div>

        <div class="column">
            <div class="column-title"><span>阅读</span><span @click="toArticle"> 查看更多 </span></div>
            <div class="article-content">
                <div class="article-item" v-for="item in articles" :key="item.id" @click="article(item.id)">
                    <img class="article-item-img" :src="item.thumb" alt="" />
                    <div class="article-item-content">
                        <span>{{ item.title }}</span>
                        <span class="description">{{ item.description }}</span>
                    </div>
                </div>
            </div>
        </div>

        <p class="footer-text">{{ church.meta.slogan }}</p>
        <tabbar />
    </div>
</template>

<script>
import Tabbar from '@/components/Tabbar'
import UserTabbar from './UserTabbar.vue'
import { getDailySentences } from '@/api/common'
import { getArticles, getAnthologies } from '@/api/article'
import { getAudios, getChurchByDomain } from '@/api/media'

export default {
    name: 'HomeIndex',
    components: { Tabbar, UserTabbar },
    data() {
        return {
            dailySentence: {},
            anthologies: [],
            audios: [],
            articles: [],
            church: {
                name: '',
                logo: '',
                meta: {
                    slogan: '',
                },
            },
        }
    },
    created() {
        getDailySentences().then((res) => {
            this.dailySentence = res.data
        })
        getAnthologies().then((res) => {
            this.anthologies = res.data.splice(0, 6)
        })
        getAudios().then((res) => {
            this.audios = res.data
        })
        getArticles().then((res) => {
            this.articles = res.data.splice(0, 6)
        })
        getChurchByDomain().then((res) => {
            this.church = res.data
        })
    },
    methods: {
        toAnthology() {
            this.$router.push('/article/anthology')
        },
        anthology(id) {
            this.$router.push({
                name: 'AnthologyDetail',
                query: { id: id },
            })
            this.$store.commit('anthology/setRouterMark', true)
        },
        audio(id) {
            this.$router.push({
                name: 'AudioDetail',
                query: { id: id },
            })
        },
        toArticle() {
            this.$router.push('/article')
        },
        article(id) {
            this.$router.push({
                name: 'ArticleDetail',
                query: { id: id },
            })
        },
    },
}
</script>

<style lang="less" scoped>
@import '../../styles/common.less';

.home {
    font-size: @medium-font-size;
}

.user {
    position: fixed;
    top: 20px;
    left: 20px;
}

.banner {
    background-color: white;

    .banner-img {
        width: 100%;
        height: 200px;
        background-size: 100% !important;
        background-position-y: center !important;
    }

    p:first-of-type {
        color: @grey;
        padding: 15px;
    }

    p:last-of-type {
        padding: 0 15px 15px;
    }
}

.column {
    background-color: white;
    padding: 10px 15px;

    .column-title {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        margin-bottom: 20px;

        span:first-of-type {
            font-size: @large-font-size;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 30%;
                background-color: rgba(148, 212, 247, 0.2);
            }
        }

        span:nth-of-type(2) {
            color: @blue;
            text-align: end;
        }
    }

    .column-content {
        display: flex;
        align-content: space-between;
        overflow-x: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            display: none;
        }

        .content-item {
            display: flex;
            flex-direction: column;
            margin-right: 15px;

            &:last-of-type {
                margin-right: 0;
            }

            .content-item-img {
                width: 90px;
                height: calc(90px / (3 / 4));
                object-fit: cover;
                // aspect-ratio: 3/4;
                border-radius: @small-border-radius;
                margin-bottom: 10px;
            }
        }
    }
}

.column:nth-of-type(4) {
    .column-content .content-item {
        .content-item-img {
            width: 90px;
            height: calc(90px / (1 / 1));
            object-fit: cover;
            // aspect-ratio: 1/1;
            border-radius: @large-border-radius;
        }

        span:last-of-type {
            font-size: @small-font-size;
            margin-top: 5px;
            color: @grey;
        }
    }
}

.article-item {
    display: flex;
    margin-bottom: 20px;

    .article-item-img {
        flex: 0 0 auto;
        width: 100px;
        height: calc(100px / (7 / 4));
        object-fit: cover;
        // aspect-ratio: 7/4;
        border-radius: @large-border-radius;
        vertical-align: top;
        margin-right: 10px;
    }

    .article-item-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .description {
        font-size: @small-font-size;
        color: @grey;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }
}

.footer-text {
    font-size: @small-font-size;
    color: @grey;
    text-align: center;
    padding: 15px;
}
</style>
